export const RECENT_DOCS_LIMIT = 5
export const HEADING_EXTRACT_DELAY = 100
export const RECENT_PRIORITY_BASE = 200
export const MIN_SEARCH_LENGTH = 2
export const RANDOM_SUGGESTIONS_COUNT = 3
export const RANDOM_SUGGESTIONS_FETCH_SIZE = 100
export const CROSS_REPO_HITS_PER_PAGE = 20
export const SCOPED_SEARCH_HITS_PER_PAGE = 50

export const REPO_CONFIG = {
  RorDocs: {
    name: "RorDocs" as const,
    pathSegment: "/react-on-rails/",
    displayName: "React on Rails",
  },
  RorProDocs: {
    name: "RorProDocs" as const,
    pathSegment: "/react-on-rails-pro/",
    displayName: "React on Rails Pro",
  },
  CpFlowDocs: {
    name: "CpFlowDocs" as const,
    pathSegment: "/control-plane-flow/",
    displayName: "Control Plane Flow",
  },
} as const

export const STORAGE_KEY = "kbar-recent-docs"
export const UPDATE_EVENT_NAME = "kbar-recent-docs-update"
